<template>
  <div>
    <el-card class="mtf-head">
      <div class="custom-flex-space-between">
        <div class="curMonth">
          <el-radio-group v-model="timeDimension" class="custom-elRadioGroup" text-color="#78bfcf" fill="#ffffff">
            <el-radio-button label="1">{{ $t('AirFreight.CurrentMonth') }}</el-radio-button>
            <el-radio-button label="2">{{ $t('AirFreight.CurrentQuarter') }}</el-radio-button>
            <el-radio-button label="3">{{ $t('AirFreight.CurrentYear') }}</el-radio-button>
          </el-radio-group>
        </div>
      </div>
      <el-divider />
    </el-card>
    <div>
      <MMStatistics :time-dimension.sync="timeDimension" :customer-code.sync="customerCode" />
    </div>
  </div>
</template>
<script>
import MMStatistics from './mmStatistics.vue'

export default {
  components: {
    MMStatistics
  },
  props: {
    customerCode: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      formData: {},
      /** 周期 */
      timeDimension: '1'
    }
  },
  computed: {},
  // watch: {
  //   jobType(newValue, oldValue) {
  //     if (newValue !== oldValue) {
  //       this.circuitSelect = this.jobType
  //     }
  //   }
  // },
  mounted() {
    // this.circuitSelect = this.jobType
  },
  methods: {
    handleChange() {
      this.$emit('update:jobType', this.circuitSelect)
    }
  }
}
</script>
<style scoped>
/* 公共样式提取至内部 开始*/
.custom-input {
  border: none;
  width: 200px;
}
.custom-input >>> input {
  border: none;
  background: #f6f6f8;
}
/* 公共样式提取至内部 结束 */

.mtf1 {
  margin-top: -1px;
  border-top: #fff;
}
.mtf-head {
  margin-top: -1px;
  border-top: #fff;
}
.mtf-head >>> .el-card__body {
  padding: 10px 20px 0px 20px !important;
}

.mt10 {
  margin-top: 10px;
}
.mt16 {
  margin-top: 16px;
}
.fw600 {
  font-weight: 600;
}
.minheight350 {
  min-height: 350px;
}
.border {
  border: 1px solid #e5e7eb;
}
.borderRadius {
  border-radius: 10px;
}
.dian::before {
  content: '';
  display: inline-block;
  width: 5px;
  height: 5px;
  background: #58c6e4;
  border-radius: 50%;
  margin-right: 6px;
  margin-bottom: 2px;
}
.curMonth {
  padding: 4px 4px;
  background: #f6f6f8;
}
.elSelect {
  width: 180px;
  margin-left: 10px;
  border-radius: 8px;
}
</style>
